import { persist } from 'zustand/middleware';
import { shallow } from 'zustand/shallow';
import { createWithEqualityFn } from 'zustand/traditional';

type State = {
  customSlug?: string;
  pageId?: string;
  setCustomSlug: (customSlug?: string, pageId?: string) => void;
  hasCustomSlugForPage: (pageId: string) => boolean;
};

export const useCustomSlugForExperience = createWithEqualityFn<State>()(
  persist(
    (set, get) => ({
      customSlug: '',
      pageId: undefined,
      setCustomSlug: (customSlug, pageId) => set({ customSlug, pageId }),
      hasCustomSlugForPage: (pageId) =>
        get().pageId === pageId && !!get().customSlug,
    }),
    { name: '_ah_experience_custom_slug' }
  ),
  shallow
);
